// extracted by mini-css-extract-plugin
export var bannerItem = "prevNext-module--bannerItem--2b014";
export var bannerRow = "prevNext-module--bannerRow--8c330";
export var footerContainer = "prevNext-module--footerContainer--5d76c";
export var navButton = "prevNext-module--navButton--fb204";
export var navButtonGhost = "prevNext-module--navButtonGhost--db2a7";
export var navRow = "prevNext-module--navRow--cc8d8";